import { Component, OnInit } from '@angular/core';
import { UserService } from '../user.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { NgxSpinnerService } from "ngx-spinner"; 
import { HelperService } from '../helper.service';
import {AuthGuardService} from '../auth-guard.service';
@Component({
  selector: 'app-manage-company',
  templateUrl: './manage-company.component.html',
  styleUrls: ['./manage-company.component.css']
})
export class ManageCompanyComponent implements OnInit {
  stateLoading = false;
  stateLoadingStore = false;
  companySubmitted = false;
  divReady = false;
  primary_color: string = '';
  Storeimage: string = '';
  timezones = [];
  company_data_update:string="";
  store_added:string="";
  successMessage = HelperService.successMessage;
  companyEmpty= true;
  states = [];
  company_id:'';
  company_name:'';
  owner_name:'';
  email_Address:'';
  contact_number:'';
  address_line1:'';
  address_line2:'';
  city:'';
  State:'';
  zip:'';
  country_id:'';
  Stores = [];
  countries = [];
  companies = [];
  States = [];
  storeSubmitted = false;
  stateName: '';
 // isHidden = false;	
  public hideRuleContent = 0;
  public buttonName:any = 'Expand';

  toggle(index) {
  // toggle based on index
   this.hideRuleContent = index;
	  console.log(this.hideRuleContent);
 }	
	
  constructor(
    private fb : FormBuilder, 
    private userService: UserService, 
    private router : Router,
    private SpinnerService: NgxSpinnerService,
    private authGuard: AuthGuardService
  ) { 
      this.authGuard.userPermissions(); 
      this.userService.getCompanyAndStores().subscribe((data: any) => {
      this.companies = data.companies;
      ////console.log(data.companies.length);
      if (data.companies.length <= 0) {
        //this.router.navigate(['/add-company-store']);
        this.companyEmpty = true;
      } 
      else{
        this.companyEmpty = false;
      }
    });
  }

  ngOnInit(): void {
    this.userService.getcountries().subscribe((data: any) => {
      this.countries = data.countries;
    });

    this.userService.gettimezones().subscribe((data: any) => {
      this.timezones = data;
    });

    this.userService.getCompanyAndStores().subscribe((data: any) => {
      if (data.status == 1) {
        const company_data = data.companies['0'];
        if(company_data){
        this.company_id = company_data.company_id;
        
        ////console.log(company_data);
        this.userService.getCompanyinfo(this.company_id).subscribe((company_fetch: any) => {
          if (company_fetch.status == 1) {
            ////console.log(company_fetch)
            this.company_name = company_fetch.company_info.company_name;
            this.owner_name = company_fetch.company_info.owner_name;
            this.email_Address = company_fetch.company_info.email_Address;
            this.contact_number = company_fetch.company_info.contact_number;
            this.address_line1 = company_fetch.company_info.address_line1;
            this.address_line2 = company_fetch.company_info.address_line2;
            this.city = company_fetch.company_info.city;
            this.State = company_fetch.company_info.State;
            this.zip = company_fetch.company_info.zip;
            this.country_id = company_fetch.company_info.country;
            this.Stores = company_fetch.company_info.Stores;
            this.stateName = company_fetch.company_info.stateName;
            ////console.log(this.Stores);
            if(this.country_id){
              this.userService.getRegions(this.country_id).subscribe(res => {
                this.states = res.regions;
              })
            }
             this.company_update.get('company_id').setValue(this.company_id);
             this.company_update.get('company_name').setValue(this.company_name);
             this.company_update.get('owner_name').setValue(this.owner_name);
             this.company_update.get('email').setValue(this.email_Address);
             this.company_update.get('contact_number').setValue(this.contact_number);
             this.company_update.get('address_line1').setValue(this.address_line1);
             this.company_update.get('address_line2').setValue(this.address_line2);
             this.company_update.get('State').setValue(this.State);
             this.company_update.get('country').setValue(this.country_id);
             this.company_update.get('city').setValue(this.city);
             this.company_update.get('zip').setValue(this.zip);

              setTimeout(
                () => {
                  this.company_update.get('State').setValue(this.State)
                }, 1500);
          }
        });
      }
      }
      this.divReady = true;
      this.SpinnerService.hide(); 
    });
  }

  company_update = new FormGroup({
    company_id: new FormControl(),
    company_name: new FormControl('', [Validators.required]),
    owner_name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    contact_number: new FormControl('', [Validators.required]),
    address_line1: new FormControl('', [Validators.required]),
    address_line2: new FormControl(''),
    State: new FormControl('', [Validators.required]),
    country: new FormControl('', [Validators.required]),
    city: new FormControl('', [Validators.required]),
    zip: new FormControl('', [Validators.required]),
  });
  
  get company_form(){
    return this.company_update.controls;
  }
  
  company_submit(event){
    this.companySubmitted = true;
    event.preventDefault();
    this.SpinnerService.show(); 
    if (this.company_update.invalid) {
      this.SpinnerService.hide(); 
      return;
    }
    ////console.log(this.company_update.value);
    const companyData = this.company_update.value;
     this.userService.updateCompanyPlusStore(companyData).subscribe(resp => {
      this.SpinnerService.hide(); 
      if (resp.status == 2) {
      } else {
        this.ngOnInit();
        this.company_data_update = this.successMessage;
        setTimeout(() => {
          this.company_data_update = '';
          const company_close_modal = document.querySelector('.company_close_modal');
          if (company_close_modal instanceof HTMLElement) {
            company_close_modal.click();
          }
        }, 1000)
      }
    }) 
    return false;
  }


  changeState(event) {
    this.stateLoading = true;
    localStorage.setItem('country.id', event);
    this.userService.getRegions(event).subscribe(res => {
      this.stateLoading = false;
      this.states = res.regions;
    })
    this.company_update.get('State').setValue("");
  }
  fillStoreForm(index){
    ////console.log(this.Stores[index]);
    const store_id = this.Stores[index].id;
    const store_name = this.Stores[index].store_name;
    const owner_name = this.Stores[index].owner_name;
    const contact_number = this.Stores[index].contact_number;
    const email_Address = this.Stores[index].email_Address;
    const address_line1 = this.Stores[index].address_line1;
    const address_line2 = this.Stores[index].address_line2;
    const country = this.Stores[index].country;
    const city = this.Stores[index].city;
    const State = this.Stores[index].State;
    const zip = this.Stores[index].zip;
    const timezone = this.Stores[index].timezone;
    const primary_color = this.Stores[index].primary_color;
    const Storeimage = this.Stores[index].Storeimage;

    this.userService.getRegions(country).subscribe(res => {
      this.States = res.regions;
    });
    this.store_update.get('State').setValue(State);
    this.store_update.get('country').setValue(country);
    //////console.log(this.States);
    this.store_update.get('id').setValue(store_id);
    this.store_update.get('store_name').setValue(store_name);
    this.store_update.get('owner_name').setValue(owner_name);
    this.store_update.get('contact_number').setValue(contact_number);
    this.store_update.get('email_Address').setValue(email_Address);
    this.store_update.get('address_line1').setValue(address_line1);
    this.store_update.get('address_line2').setValue(address_line2);
    
    this.store_update.get('city').setValue(city);
    this.Storeimage = Storeimage;
   // this.store_update.get('State').setValue(State);
    this.store_update.get('zip').setValue(zip);
    this.store_update.get('primary_color').setValue(primary_color);
    this.store_update.get('timezone').setValue(timezone);
    (<HTMLInputElement>document.getElementById("cstm_color_new")).value = primary_color;
    (<HTMLInputElement>document.getElementById("cstm_color_new")).style.color = primary_color;
    (<HTMLInputElement>document.getElementById("cstm_color_new")).style.background = primary_color;
	  $("#stroehead").html("Edit Store");
  }


  store_update = new FormGroup({
    id: new FormControl(''),
    Storeimage: new FormControl(''),
    store_name: new FormControl('', [Validators.required]),
    owner_name: new FormControl('', [Validators.required]),
    contact_number: new FormControl('', [Validators.required]),
    email_Address: new FormControl('', [Validators.required]),
    address_line1: new FormControl('', [Validators.required]),
    country: new FormControl('', [Validators.required]),
    address_line2: new FormControl(''),
    city: new FormControl('', [Validators.required]),
    State: new FormControl('', [Validators.required]),
    zip: new FormControl('', [Validators.required]),
    timezone: new FormControl("", [Validators.required]),
    primary_color: new FormControl(''),
  });

  get store_form(){
    return this.store_update.controls;
  }

  store_submit(event){
    event.preventDefault();
    this.storeSubmitted = true;
    this.SpinnerService.show(); 
    ////console.log(this.store_update.value);
    if (this.store_update.invalid) {
      this.SpinnerService.hide(); 
      return;
    }
    ////console.log(this.store_update.value);
    const storeData = this.store_update.value;
    const store_id = this.store_update.value.id;
    const country = this.store_update.value.country;
    if(store_id){
      this.userService.updateStore(storeData).subscribe(resp => {
        this.SpinnerService.hide(); 
        ////console.log(resp);
        if (resp.status == 2) {
        } else {
          this.ngOnInit();
          this.store_added = this.successMessage;
          setTimeout(() => {
            this.store_added = '';
            const close_store_modal = document.querySelector('.close_store_modal');
            if (close_store_modal instanceof HTMLElement) {
              close_store_modal.click();
            }
            this.resetStoreForm();
          }, 1000);
        }
      })  
    }
    else{
      this.userService.addNewStore(storeData,this.company_id).subscribe(resp => {
        this.SpinnerService.hide(); 
        ////console.log(resp);
        if (resp.status == 2) {
        } else {
          this.ngOnInit();
          this.store_added = this.successMessage;
          setTimeout(() => {
            this.store_added = '';
            const close_store_modal = document.querySelector('.close_store_modal');
            if (close_store_modal instanceof HTMLElement) {
              close_store_modal.click();
            }
            this.resetStoreForm();
          }, 1000);
        }
      })  
    }
  }
  changeStateStore(event) {
    this.stateLoadingStore = true;
    this.userService.getRegions(event).subscribe(res => {
      this.States = res.regions;
      this.stateLoadingStore = false;
    })
    this.store_update.get('State').setValue("");

  }

  handleChangeComplete(event){
    const primary_color = event;
    this.store_update.get('primary_color').setValue(primary_color);
    (<HTMLInputElement>document.getElementById("cstm_color_new")).value = event;
    (<HTMLInputElement>document.getElementById("cstm_color_new")).style.color = event;
    (<HTMLInputElement>document.getElementById("cstm_color_new")).style.background = event; 
     //this.CompanyForm['controls']['StoresArray']['controls'][index]['controls'].primary_color.patchValue(event);
  }
  addStore(){
    this.resetStoreForm();
  }
  resetStoreForm(){
    this.Storeimage = null;
    this.storeSubmitted = false;
    ////console.log('addStore');
    this.store_update.reset();
    this.store_update.get('timezone').setValue("");
    this.store_update.get('State').setValue("");
    this.store_update.get('country').setValue("");
    this.store_update.get('primary_color').setValue("");
    (<HTMLInputElement>document.getElementById("cstm_color_new")).value = "";
    (<HTMLInputElement>document.getElementById("cstm_color_new")).style.color = "";
    (<HTMLInputElement>document.getElementById("cstm_color_new")).style.background = ""; 
	  $("#stroehead").html("Add Store");
  }
  selectImageStore(event) {
    this.SpinnerService.show(); 
    let file = event.target.files[0];
    
    // File Preview
    const reader = new FileReader();
    reader.onload = (e: any) => {
      ////console.log(e.target.result);
      this.Storeimage = e.target.result;
      this.store_update.get('Storeimage').patchValue(e.target.result);
      this.SpinnerService.hide(); 
    }
    reader.readAsDataURL(file)

  }
    updateUrl(event,store_id,index) {
    this.Stores[index]['Storeimage'] = 'assets/images/profiles.png';
  }
}
